"use strict";

exports.__esModule = true;
function createTokenClass() {
	return function (value) {
		if (value) {
			this.v = value;
		}
	};
}

exports.createTokenClass = createTokenClass;


// WEBPACK FOOTER //
// ./~/linkifyjs/lib/linkify/core/tokens/create-token-class.js